module.exports = __webpack_public_path__ + "img/1-1.d547bd8f.png";